import thunkMiddleware from 'redux-thunk';
import rootReducer from "./reducers";
import { createHashHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { loadState, saveState, subscribe } from './storage/localStorage';
import throttle from "lodash-es/throttle";
import parse_url from "locutus/php/url/parse_url";
import {reduxStoreChanged} from "./actions";

const base = document.querySelector("base");
const url = (base && base.getAttribute('href')) || "";
let basepath = "";
if (url !== "") {
    basepath = parse_url(url).path;
}

//console.log(window.location.pathname);

/*export const history = createBrowserHistory({
    basename: '#'
});*/

// hashRouter bugfix
if (window.location.href.indexOf("#") === -1) {
    window.location.hash = "/"; // hashType from createHashHistory
}

export const history = createHashHistory();

function configureStore(preloadedState: any) {
    const store = createStore(
        rootReducer(history), // root reducer with router state
        preloadedState,
        compose(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                thunkMiddleware
            ),
        ),
    );
    if (module.hot) {
        module.hot.accept('./reducers', () => {
            store.replaceReducer(rootReducer(history));
        });
    }
    return store;
}

export const store = configureStore(loadState());

store.subscribe(throttle(() => {
    saveState(store.getState());
}, 1000));

/*subscribe((newState) => {
    const currentState = JSON.parse(JSON.stringify(store.getState()));

    // TODO ezt nem itt kéne tudni megcsinálni. A template azért nem kell mert az a menü és tartalom adatait tartalmazza amik az adott ablakra vonatkoznak
    delete currentState.app.template;
    delete newState.app.template;
    delete currentState.router;
    delete newState.router;

    if (JSON.stringify(currentState) !== JSON.stringify(newState)) {
        store.dispatch(reduxStoreChanged(newState));
    }
})*/

import {default as reduxConnect} from "react-redux/es/connect/connect";
import connectAdvanced from "react-redux/es/components/connectAdvanced";

export const connect = (state: (state: any) => any, functions?: {[key: string]: Function}): <T extends any>(Component: T) => T => {
    return reduxConnect(state, functions);
}
export {connectAdvanced};